import { mdiFileOutline, mdiHomeOutline } from '@mdi/js'

export default [
  {
    title: 'Presentation',
    icon: mdiHomeOutline,
    to: 'home',
  },
  {
    title: 'Project Organisation',
    icon: mdiFileOutline,
    to: 'second-page',
  },
]
